import { render, staticRenderFns } from "./ReviewUsLinks.vue?vue&type=template&id=372c70f0"
import script from "./ReviewUsLinks.vue?vue&type=script&lang=js"
export * from "./ReviewUsLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports